import validate from "/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/middleware/auth.global.ts";
import manifest_45route_45rule from "/var/www_vsf/releases/72838d0b-534d-4b1d-b0de-62cf43e57a40/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}